






import {Vue, Component} from 'vue-property-decorator';
import DisplayInfoSon from '@/components/accumulation/DisplayInfoComponent.vue';
@Component({
  components: {
    DisplayInfoSon
  }
})
export default class DisplayInfoPopup extends Vue {}
